import { HTMLAttributes } from 'react';
import classNames from 'classnames';
import './checkbox.scss';

interface CheckBoxProps extends HTMLAttributes<HTMLDivElement> {
	name: string;
	size?: number;
	invert?: boolean;
	disabled?: boolean;
	value?: boolean;
	label?: string;
	isBlock?: boolean;
	setValue?: React.Dispatch<React.SetStateAction<boolean>>
};

const CheckBox: React.FC<CheckBoxProps> = (props) => {
	
	const { name, disabled = false, size = 18, invert = false, 
		setValue, value, label, children, isBlock = false, 
		className, ...otherProps 
	} = props;
	
	const id = "rdcc_" + name;
	const _size = `${size}px`;

	const renderInput = () => (
		<input
			id={id}
			style={{ minWidth: `${size}px`, minHeight: _size }}
			name={name} 
			className="rdcc" 
			type="checkbox" 
			checked={ value }
			onChange={ e => !!setValue && setValue(e.target.checked) }   
			disabled={disabled} 
		/>
	);

	const renderLabel = () => {
		if ( !!children )
			return <label htmlFor={id} className='rdc-ctrl-checkbox__label body-small'>{children}</label>;
		else if ( !!label )
			return <label htmlFor={id} className='rdc-ctrl-checkbox__label body-small'>{label}</label>;
		else 
			return null;
	};

	if ( !!children || !!label || isBlock ) 
		return (
			<div className={classNames("rdc-ctrl-checkbox", className, { "disabled": disabled, "rdcc_block": isBlock, "invert": invert } )} style={{ ...otherProps.style, gap: `${size/3}px` }}>
				{renderInput()}
				{renderLabel()}
			</div>
		);
	else 
		return renderInput();
};

export default CheckBox;
